module.exports = __webpack_public_path__ + "media/images/icons/notifications-176be38a1043c8d0d0032003dc71cf8f.svg";